import {POST, GET, DELETE} from "@/services/gateway";

const listCompare = ({pagination,}) => {
  return POST('recovery/compare/list', {pagination})
}

const listComparison = ({pagination, id, searchTerm}) => {
  return POST(`recovery/compare/comparison`, {pagination, id, searchTerm})
}

const deleteCompare = (id) => {
  return DELETE(`recovery/export`, id)
}

const downloadCompare = (id) => {
  return GET(`recovery/export/${id}/download`)
}

const cancelCompare = (id) => {
  return GET(`salesforce/compare/${id}/cancel`)
}

export {
  listCompare,
  downloadCompare,
  deleteCompare,
  cancelCompare,
  listComparison,
}
